import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import { theme } from '../../theme/theme'
import { Title6 } from '../styles/Typography'
import { MenuItem } from '../../utils/menus/types'
import { useEmitEvent } from '../../hooks/analytics/useEmitEvent'
import { TrackingEvents } from '@estercare/ester-shared'

interface Props {
  item: MenuItem
}
export const MenuListItem = ({ item }: Props) => {
  const emitEvent = useEmitEvent()

  const handleClick = () => {
    emitEvent({
      eventType: TrackingEvents.NAVIGATE,

      action: 'sidebar_navigation',
      options: {
        metadata: {
          destinationPage: item.path,
          menuItemName: item.name,
        },
      },
    })
  }

  return (
    <Item to={item.path} end onClick={handleClick}>
      {({ isActive }) => (
        <>
          <IconContainer>
            {item.icon && <item.icon size={24} color={isActive ? theme.color.plum : theme.color.black} />}
            {!!item.badgeCount && <Badge>{item.badgeCount}</Badge>}
          </IconContainer>
          <Title6>{item.name}</Title6>
        </>
      )}
    </Item>
  )
}

const Badge = styled.span`
  position: absolute;
  top: -2px;
  right: 8px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${theme.color.orange};
  font-size: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.color.white};
`

const IconContainer = styled.div`
  position: relative;
  padding-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`
const Item = styled(NavLink)`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding: 8px;
  margin-bottom: 4px;
  width: 100%;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.2s;
  color: ${theme.color.black};
  font-size: 16;
  font-family: 'neue-montreal';
  font-weight: 500;
  letter-spacing: 0.1;
  background-color: ${theme.color.beigeLight};
  &:hover {
    background-color: ${theme.color.beigeDark};
  }
  &.active {
    background-color: ${theme.color.beigeDark};
    color: ${theme.color.plum};
  }
`
